export default __webpack_public_path__ + "static/media/gallery_04.ce7f4642.jpg";